/* eslint-disable func-names */

G.Refiller = function (lvl, boardCandies) {
  // imports
  const { treasureHuntMgr } = G.TreasureHunt;
  const numberOfTypes = lvl.nrOfTypes;

  this._boardCandies = boardCandies;
  this._goalCandyNoGoalLimit = lvl.goalCandyNoLimit || false;
  this._goalCandyBoardLimit = lvl.goalCandyBoardLimit || Infinity;

  this.drops = G.Utils.clone(lvl.drops);
  this.goalDrops = lvl.goalDrops ? G.Utils.clone(lvl.goalDrops) : [];

  this.predefinedDrops = lvl.predefinedDrops ? G.Utils.clone(lvl.predefinedDrops) : [];

  if (typeof this.drops.chest === 'undefined') this.drops.chest = 0;
  if (typeof this.drops.infection === 'undefined') this.drops.infection = 0;
  if (typeof this.drops.chain === 'undefined') this.drops.chain = 0;
  if (typeof this.drops.goalCandy === 'undefined') this.drops.goalCandy = 0;
  if (typeof this.drops.burntCandy === 'undefined') this.drops.burntCandy = 0;

  this.drops.chest *= G.lvl.coinChanceProb;

  const { lvlIndex } = game.state.getCurrentState();
  this.treasureHunt = treasureHuntMgr.isLevelTreasureHuntActive(lvlIndex);
  if (this.treasureHunt) {
    this.initTreasureHuntOverwrites(lvlIndex);
  }

  const isTutorialLevel = game.state.getCurrentState().lvlData.tutID;
  const checkFortune = async () => { // Check if the fortune cookie is on through this quick async function because it comes as a promise
    if (await OMT.feature.getFortuneCookieEvent() && !isTutorialLevel) {
      this.drops.fortune = G.featureUnlock.fortuneCookie.dropChance;
    }
  };
  checkFortune();

  this.regularChanceTable = this._createRegularChanceTable(
    numberOfTypes, this.drops,
  );
};

G.Refiller.prototype.initTreasureHuntOverwrites = function (lvlIndex) {
  this.drops.chest = G.TreasureHunt.treasureHuntMgr.getChestDropOverwrite();

  // overwrite predefined drops
  // so chest will for sure appear
  // if player is playing level 21 for first time
  if (lvlIndex === 20 && G.saveState.getLastPassedLevelNr() === 20) {
    this.predefinedDrops[3].push('r', 'r', 'r', 'r', 'r', 'chest_th');
  }
};

G.Refiller.prototype.getTypeToDrop = function (column) {
  // imports
  // eslint-disable-next-line no-unused-vars
  const { treasureHuntMgr } = G.TreasureHunt;

  let pre = this.checkPredifinedDrops(column);
  if (pre) {
    if (pre[0] === 'r') {
      pre = this.getEditorSymbolFromChanceTable(this.regularChanceTable) + pre.substr(1);
    }
    return pre;
  }

  this._substractGoalDropCounter();

  const goalDrop = this._checkGoalDropList();
  if (goalDrop) return goalDrop;

  const fortuneDropChance = (G.lvl.moves > G.featureUnlock.fortuneCookie.movesLeft) && !G.lvl.isGoalAchieved();
  const goalCandy = Math.random() < this.drops.goalCandy / 100;
  const burntCandy = Math.random() < this.drops.burntCandy / 100;
  const chest = Math.random() < this.drops.chest / 100;
  const fortune = Math.random() < (fortuneDropChance ? this.drops.fortune : 0) / 100;
  const chain = Math.random() < this.drops.chain / 100;
  const infection = Math.random() < this.drops.infection / 100;
  const box = Math.random() < G.Utils.defined(this.drops.bx, 0) / 100;

  if (goalCandy && this._checkIfCanDropHardCandy()) return 'goalCandy';
  if (burntCandy && this._checkIfCanDropHardCandy()) return 'burntCandy';
  if (fortune && !this.fortuneHasDropped) {
    this.fortuneHasDropped = true;
    return 'fortune';
  }
  if (chest) {
    if (this.treasureHunt) {
      return 'chest_th';
    }

    return 'chest';
  }
  if (infection) return 'infection';

  let rndType = this.getEditorSymbolFromChanceTable(this.regularChanceTable);

  if (chain) {
    const chainLevel = this._getWeightedRandomFromDrops(['W|1', 'W|2', 'W|3']);
    rndType = `${rndType}:${chainLevel}`;
    if (rndType === '0') console.log(rndType);
  } else if (box) {
    rndType = `${rndType}:${this._getBoxColor()}`;
  }

  return rndType;
};

G.Refiller.prototype._checkIfCanDropHardCandy = function () {
  const goalTarget = G.lvl.goalMgr.getGoalLeftAmount('goalCandy') || 0;
  const amountOfGoalCandies = this._boardCandies.getAllTokensWithTag('goalCandy').length;
  const amountOfBurntCandies = this._boardCandies.getAllTokensWithTag('burntCandy').length;

  if (this._goalCandyNoGoalLimit) {
    return (amountOfGoalCandies + amountOfBurntCandies) < this._goalCandyBoardLimit;
  }
  return (amountOfGoalCandies + amountOfBurntCandies) < Math.min(goalTarget, this._goalCandyBoardLimit);
};

G.Refiller.prototype.checkPredifinedDrops = function (column) {
  if (this.predefinedDrops[column]) {
    return this.predefinedDrops[column].shift();
  }

  return null;
};

G.Refiller.prototype._createRegularChanceTable = function (nrOfTypes, additionalChances) {
  const regularTypes = G.Helpers.candyDataMgr.getTypesWithTag('regular').slice(0, nrOfTypes);

  const additionalChancesSum = Object.keys(additionalChances)
    .filter((key) => regularTypes.find((type) => type.editorSymbol === key))
    .reduce((acc, key) => acc + additionalChances[key], 0);

  const baseChance = (100 - additionalChancesSum) / nrOfTypes;
  let currentChanceStart = 0;

  const table = regularTypes.map((type) => {
    currentChanceStart += (baseChance + (additionalChances[type.editorSymbol] || 0)) / 100;
    const entry = [currentChanceStart, type];
    return entry;
  });

  return table;
};

G.Refiller.prototype._getBoxColor = function () {
  const { drops } = this;
  return G.Utils.getRandomWeightedElement(
    ['bx|r', 'bx|1', 'bx|2', 'bx|3', 'bx|4', 'bx|5', 'bx|6'],
    (elem) => drops[elem] || 0,
  );
};

// eslint-disable-next-line consistent-return
G.Refiller.prototype.getEditorSymbolFromChanceTable = function (chanceTable) {
  const rnd = game.rnd.rnd();
  for (let i = 0; i < chanceTable.length; i++) {
    if (rnd <= chanceTable[i][0]) return chanceTable[i][1].editorSymbol;
  }
};

G.Refiller.prototype._checkGoalDropList = function () {
  for (let i = 0, len = this.goalDrops.length; i < len; i++) {
    if (this.goalDrops[i][1] <= 0) {
      const result = this.goalDrops[i][0];
      this.goalDrops.splice(i, 1);
      return result;
    }
  }

  return false;
};

G.Refiller.prototype._substractGoalDropCounter = function () {
  for (let i = 0, len = this.goalDrops.length; i < len; i++) {
    this.goalDrops[i][1] = this.goalDrops[i][1] - 1;
  }
};

G.Refiller.prototype._getWeightedRandomFromDrops = function (elements) {
  const { drops } = this;
  return G.Utils.getRandomWeightedElement(
    elements,
    (elem) => drops[elem] || 0,
  );
};
